import { supabase } from '@/lib/supabase';

export interface AuditEntry {
  action: string;
  entity_type: string;
  entity_id?: string;
  entity_label?: string;
  old_value?: Record<string, unknown> | null;
  new_value?: Record<string, unknown> | null;
  notes?: string;
}

/**
 * Write a record to the audit_log table.
 * Fails silently — audit logging should never block the main operation.
 */
export async function writeAuditLog(entry: AuditEntry): Promise<void> {
  try {
    const { data: { user } } = await supabase.auth.getUser();

    await supabase.from('audit_log').insert([{
      user_id: user?.id ?? null,
      user_email: user?.email ?? null,
      action: entry.action,
      entity_type: entry.entity_type,
      entity_id: entry.entity_id ?? null,
      entity_label: entry.entity_label ?? null,
      old_value: entry.old_value ?? null,
      new_value: entry.new_value ?? null,
      notes: entry.notes ?? null,
    }]);
  } catch {
    // Intentionally silent — audit log failures must not disrupt normal operations
  }
}
